//kvp of sales-financing relationship types to associated company roles for searching
export default {
  'Co-Rep': 'Talent Agencies',
  'International Sales': 'Talent Agencies',
  Financiers: 'Financing',
};
